import React, { memo, useMemo } from 'react'
import Tooltip from '@mui/material/Tooltip'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

const CustomTooltip = ({
  header = null,
  message = null,
  children,
  minWidth = 250,
  headerStyles,
  messageStyles,
  wrapperStyles,
  tooltipSx,
  arrowSx,
  arrow = true,
  placement = 'bottom',
  ...props
}) => {
  const tooltipContent = useMemo(
    () => (
      <Box sx={{ minWidth, ...wrapperStyles }}>
        {header && (
          <Box
            sx={{
              backgroundColor: 'primary.main',
              color: 'primary.contrastText',
              px: 2,
              py: 2,
              borderTopLeftRadius: '8px',
              borderTopRightRadius: '8px',
              ...headerStyles
            }}
          >
            {typeof header === 'string' ? (
              <Typography
                variant="subtitle2"
                sx={{ fontWeight: 600, color: 'white' }}
              >
                {header}
              </Typography>
            ) : (
              header
            )}
          </Box>
        )}
        <Box
          sx={{
            p: 2,
            backgroundColor: 'background.paper',
            borderRadius: header ? '0 0 8px 8px' : '8px',
            color: 'text.primary',
            ...messageStyles
          }}
        >
          {typeof message === 'string' ? (
            <Typography variant="body2">{message}</Typography>
          ) : (
            message
          )}
        </Box>
      </Box>
    ),
    [header, message, minWidth, headerStyles, messageStyles, wrapperStyles]
  )

  const arrowColor = useMemo(() => {
    if (header && placement.startsWith('bottom')) {
      return headerStyles?.backgroundColor || 'primary.main'
    }

    return 'background.paper'
  }, [header, placement, headerStyles?.backgroundColor])

  const componentsProps = useMemo(
    () => ({
      tooltip: {
        sx: {
          backgroundColor: 'background.paper',
          padding: 0,
          borderRadius: '8px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
          ...tooltipSx
        }
      },
      arrow: {
        sx: {
          color: arrowColor,
          ...arrowSx
        }
      }
    }),
    [tooltipSx, arrowColor, arrowSx]
  )

  if (!message && !header) {
    return children
  }

  return (
    <Tooltip
      title={tooltipContent}
      componentsProps={componentsProps}
      placement={placement}
      arrow={arrow}
      {...props}
    >
      {children}
    </Tooltip>
  )
}

export default memo(CustomTooltip)
